const Filter = ({ name, withDelete, onFilterClick, removeFilterHandler }) => {
  return (
    <div className={`flex  w-min max-w-32 bg-cyan-light-grayish rounded-md cursor-pointer ${!withDelete && 'group hover:bg-cyan-desaturated-dark'}`} onClick={() => !withDelete && onFilterClick(name)}>
      <p className="font-bold text-cyan-desaturated-dark mx-2 my-1 text-sm cursor-pointer group-hover:text-white">
        {name}
      </p>
      {withDelete && (
        <div className="flex justify-center items-center w-8 bg-cyan-desaturated-dark rounded-r-md cursor-pointer hover:bg-cyan-very-dark-grayish" onClick={() => removeFilterHandler(name)}>
          <svg
            className="inline-block"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
          >
            <path
              fill="#FFF"
              fill-rule="evenodd"
              d="M11.314 0l2.121 2.121-4.596 4.596 4.596 4.597-2.121 2.121-4.597-4.596-4.596 4.596L0 11.314l4.596-4.597L0 2.121 2.121 0l4.596 4.596L11.314 0z"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Filter;
